import { render, staticRenderFns } from "./EduDistributionChart.vue?vue&type=template&id=755428a3&scoped=true"
import script from "./EduDistributionChart.vue?vue&type=script&lang=js"
export * from "./EduDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./EduDistributionChart.vue?vue&type=style&index=0&id=755428a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755428a3",
  null
  
)

export default component.exports